import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import styled from 'styled-components';
const Container = styled.ul `
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 0;
  padding: 0;
  color: ${brand.primary.blue};
`;
const Tag = styled.li `
  ${fonts.dmSans.regular};

  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  font-size: ${fluid(12, 14)};
  line-height: 1.5;
  text-transform: uppercase;
  border-radius: 8px;
  border: 1px solid currentColor;
  opacity: 0.7;
`;
const TopicTagsStyles = {
    Container,
    Tag,
};
export default TopicTagsStyles;
